import { AppState } from "@/store/state";
import { UiState } from "@/store/ui/state";
import { Component, HostBinding, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppService } from "@services/app.service";
import { User } from "firebase/auth";
import { Observable } from "rxjs";

const BASE_CLASSES = "main-sidebar elevation-4";
@Component({
  selector: "app-menu-sidebar",
  templateUrl: "./menu-sidebar.component.html",
  styleUrls: ["./menu-sidebar.component.scss"],
})
export class MenuSidebarComponent implements OnInit {
  @HostBinding("class") classes: string = BASE_CLASSES;
  public ui: Observable<UiState>;
  public user?: User;
  public menuItems: any[] = [];
  public menu = MENU;
  userType: string = "";
  role: string = "";

  constructor(
    public appService: AppService,
    private store: Store<AppState>
  ) {}

  ngOnInit() {
    this.userType = localStorage.getItem("userType");
    this.role = localStorage.getItem("role");
    this.ui = this.store.select("ui");
    this.ui.subscribe((state: UiState) => {
      this.classes = `${BASE_CLASSES} ${state.sidebarSkin}`;
    });
    this.user = this.appService.user;
    switch (this.role) {
      case "Admin":
        this.menuItems = MENU;
        break;
      case "Data Entry Operator":
        this.menuItems = DataEntryMenu;
        break;
      case "Software Developer":
        this.menuItems = DeveloperMenu;
        break;
        case "Tech Lead":
        this.menuItems = DeveloperMenu;
        break;
        case "Software Tester":
        this.menuItems = DeveloperMenu;
        break;
      default:
        this.menuItems = []; // or show limited menu
        break;
    }
  }
}

export const MENU = [
  {
    name: "Employee Details",
    iconClasses: "fas fa-tachometer-alt",
    children: [
      {
        name: "Add New Employee",
        iconClasses: "fa fa-users",
        path: ["/main/new-joining-form"],
      },
      {
        name: "View New Employee",
        iconClasses: "fa fa-table",
        path: ["/main/new-joining-report"],
      },
      {
        name: "Attendance Report",
        iconClasses: "fa fa-address-card",
        path: ["/main/new-joining-attendance-report"],
      },
      {
        name: "Payroll Table",
        iconClasses: "fa fa-credit-card",
        path: ["/main/new-joining-payroll"],
      },
    ],
  },
  {
    name: "Work Hours Entry Details",
    iconClasses: "fa-solid fa-file-spreadsheet",
    children: [
      {
        name: "Data Entry",
        iconClasses: "fa fa-table",
        path: ["/main/worksheet-entry-table"],
      },
      {
        name: "Support Team Entry",
        iconClasses: "fa fa-building",
        path: ["/main/development-worksheet-entry-table"],
      },
    ],
  },
];

export const DataEntryMenu = [
  {
    name: "Worksheet Entry",
    iconClasses: "fa fa-file",
    path: ["/main/employee-worksheet-entry"],
  },
  {
    name: "Worksheet Entry Details",
    iconClasses: "fa fa-table",
    path: ['/main/data-entry-table']
  }
];

export const DeveloperMenu = [
  {
    name: "Worksheet Entry",
    iconClasses: "fa fa-file",
    path: ["/main/development-worksheet-entry"],
  },
];
